module.exports = __webpack_public_path__ + "img/solution-bgimg.39ce2234.png";